import { CSSProperties } from 'react'
import SliderCustom from './SliderCustom'
import { lightTheme } from '@/customTheme'
import { useTranslation } from 'react-i18next'

function SliderPopover({
  icon,
  name,
  listValues,
  minValue,
  maxValue,
  value,
  step,
  onChangeValue,
  onFinalChangeValue,
  logicMaximum,
  logicMinimum,
  style,
}: {
  icon: JSX.Element
  name: string
  listValues: number[]
  minValue: number
  maxValue: number
  value: number
  step?: number
  onChangeValue: Function
  onFinalChangeValue?: Function
  logicMaximum?: number
  logicMinimum?: number
  style?: CSSProperties
}) {
  const { t } = useTranslation()

  return (
      <SliderCustom
        icon={icon}
        name={name}
        listValues={listValues}
        minValue={minValue}
        maxValue={maxValue}
        value={value}
        step={step}
        onChangeValue={onChangeValue}
        onFinalChangeValue={onFinalChangeValue}
        logicMaximum={logicMaximum}
        logicMinimum={logicMinimum}
        style={{ marginTop: 0, color: lightTheme.colors.blackGray, ...style }}
      />
  )
}

export default SliderPopover
